import React from 'react';
import { componentService } from 'js/services/component.service';

export const DynamicForgotPassword = React.lazy(() => import(/* webpackChunkName: "dynamic-forgot-password" */ './DynamicForgotPassword'));

componentService.registerPageComponents({ 'dynamic-forgot-password': DynamicForgotPassword });
